"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _FoodMenu = require("./FoodMenu.context");
var _components = require("./components");
var _variants = require("./components/variants");
require("./FoodMenu.css");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var FoodMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FoodMenu, _React$Component);
  var _super = _createSuper(FoodMenu);
  function FoodMenu() {
    (0, _classCallCheck2["default"])(this, FoodMenu);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(FoodMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        navDisplayVariant = _this$props.navDisplayVariant,
        categoryDisplayVariant = _this$props.categoryDisplayVariant,
        itemDisplayVariant = _this$props.itemDisplayVariant,
        menu = _this$props.menu,
        header = _this$props.header,
        centerHeader = _this$props.centerHeader,
        centerNavigation = _this$props.centerNavigation,
        disableModifiers = _this$props.disableModifiers,
        disableSchedules = _this$props.disableSchedules,
        cart = _this$props.cart;
      var variantContext = {
        navDisplay: navDisplayVariant,
        categoryDisplay: categoryDisplayVariant,
        itemDisplay: itemDisplayVariant
      };
      var headerStyle = centerHeader ? {
        textAlign: 'center'
      } : {};
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FoodMenu.VariantProvider, {
        value: (0, _variants.computeVariants)(variantContext)
      }, /*#__PURE__*/_react["default"].createElement(_FoodMenu.MenuProvider, {
        value: _objectSpread({}, menu, {
          disableModifiers: disableModifiers,
          disableSchedules: disableSchedules
        })
      }, /*#__PURE__*/_react["default"].createElement(_FoodMenu.CartProvider, {
        value: cart
      }, header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h1",
        className: "fcfm-main-header",
        style: headerStyle
      }, header), /*#__PURE__*/_react["default"].createElement(_components.MenuNavigation, {
        center: centerNavigation
      })))));
    }
  }]);
  return FoodMenu;
}(_react["default"].Component);
exports["default"] = FoodMenu;
FoodMenu.propTypes = {
  navDisplayVariant: _propTypes["default"].oneOf(['BasicTabs', 'TabsCategorySidebar']),
  categoryDisplayVariant: _propTypes["default"].oneOf(['VerticalList', 'Column', 'VerticalCardRow', 'HorizontalCardRow']),
  itemDisplayVariant: _propTypes["default"].oneOf(['Basic', 'BasicCondensed', 'HorizontalCard', 'VerticalCard']),
  menu: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired,
  header: _propTypes["default"].string,
  centerHeader: _propTypes["default"].bool,
  centerNavigation: _propTypes["default"].bool,
  disableModifiers: _propTypes["default"].bool,
  disableSchedules: _propTypes["default"].bool,
  cart: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].shape({
    items: _propTypes["default"].array,
    addItem: _propTypes["default"].func,
    removeItem: _propTypes["default"].func,
    updateItem: _propTypes["default"].func,
    containsItem: _propTypes["default"].func,
    clearCart: _propTypes["default"].func,
    getItemIndex: _propTypes["default"].func
  })])
};
FoodMenu.defaultProps = {
  navDisplayVariant: 'BasicTabs',
  categoryDisplayVariant: 'VerticalList',
  itemDisplayVariant: 'Basic',
  header: 'Menu',
  centerHeader: false,
  centerNavigation: false,
  disableModifiers: false,
  disableSchedules: false,
  cart: false
};